// extracted by mini-css-extract-plugin
export default {"root":"TitleArea_root__utSFw","logo":"TitleArea_logo__xiaU6"};